/**
 * Created by dreamc_t on 2017/2/13.
 */

require('./style.scss');

let Video = require('./playback');

let Stream = require('./stream');

let cutDown = require('../countDown');

let utils = require('f.component.util.pc');

let live_video = {
    init: function(options) {
        this.options = options;

        this.success(this.options);
    },

    success: function(data) {
        // console.log("live_videosuccess===",data);
        let self = this;
        let container = this.options.container;
        if (data.isLive != true && (typeof data.list[0].liveVideoId === 'undefined' || data.list[0].liveVideoId == '')) {
            return;
        } // 不是直播中且不存在直播间id
        this.islive = data.isLive;

        let currentvideo;
        let channelID = data.list[0].channelId || '', // 栏目id
            realStreamUrl = data.list[0].rtmp, // 可能为空
            isLive = data.isLive,
            liveVideoId = data.list[0].liveVideoId,
            isDanmu = typeof data.isDanmu === 'undefined' ? false : data.isDanmu,
            livewidth = data.livewidth,
            liveheight = data.liveheight,
            picUrl = data.list[0].poster || '//y0.ifengimg.com/ffeefe4ba8f67e3e/2015/2/livepic-nobtn.png',
            list = data.list;
        if ((channelID != '' || realStreamUrl != '') && isLive) {
            // 只有是直播，并且直播流地址不为空
            // debugger
            let videoOptions = {
                livewidth: livewidth,
                liveheight: liveheight,
                list: list,
                danmu: isDanmu
            };

            let nowTime = new Date().valueOf();
            // console.log(data.start_date > nowTime);
            if (data.start_date > nowTime) {
                // 预告
                this.videoBgStyle(container, picUrl, livewidth, liveheight);
                // $(container).html('<span class="icon-video"></span>'); //8月22号需求，去除播放按钮，并添加遮罩层，背景图拉伸充满视频框
                let cutdown = new cutDown(data.start_date);

                cutdown.begin();

                cutdown.renderTo($(container));

                cutdown.on('end', function() {
                    $(container).html('');
                    currentvideo = new Stream(videoOptions);
                    currentvideo.renderTo($(container));
                });

                this.cutdown = cutdown;
            } else {
                // 直播中
                currentvideo = new Stream(videoOptions);
                currentvideo.renderTo($(container));
            }
        } else if (liveVideoId != '') {
            // 点播
            $(container).html('<span class="icon-video"></span>');
            this.videoBgStyle(container, picUrl, livewidth, liveheight);

            $(container).one('click', function() {
                // $(container).find('img').remove();

                $(container)
                    .find('span')
                    .remove();
                let videoOptions = {
                    livewidth: data.livewidth,
                    liveheight: data.liveheight,
                    list: list
                };
                // console.log(videoOptions);
                let currentvideo = new Video(videoOptions, false);
                currentvideo.renderTo($(container));

                self.playback = currentvideo;
                //  console.log(self);
            });
        }
    },
    videoBgStyle: function(container, picUrl, livewidth, liveheight) {
        $(container).css({ 'background': 'url(' + picUrl + ') no-repeat center center', 'height': liveheight + 'px', 'background-size': 'cover' });
        $(container).prepend('<div style="position:absolute;width:100%;height:100%;background: rgb(0,0,0); opacity: 0.4; filter:alpha(opacity=0.4);"></div>');
    }
};

module.exports = live_video;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.videohead.pc/app/modules/video/index.js